import React from 'react';
import {func} from 'prop-types';
import {Form} from 'semantic-ui-react';
import {EmptyFunc} from "../../../utils/DBUtils";
import catchUnsavedChanges from 'hoc/catchUnsavedChanges';

// Originally implemented to be stateless,
// but since the value needs to be kept track of to change according to other values (linked values, color picker)
// now keeping track of state. This is duplicate logic of AutoSaveField so might be better to pull up into that
class OnBlurTextInput extends React.PureComponent {
    static propTypes = {
        // provided by catchUnsavedChanges HOC
        isEditing: func.isRequired,
        doneEditing: func.isRequired,

        onChange: func,
        getTextLengthCallback: func
    };

    static defaultProps = {
        onChange: EmptyFunc,
        getTextLengthCallback: EmptyFunc
    };

    constructor(props) {
        super(props);
        this.state = {
            value: props.value
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (this.props.value !== nextProps.value) {
            this.setState({
                value: nextProps.value
            });
        }
    }

    onBlur = (event, data) => {
        this.props.onChange(event, {});
        this.props.doneEditing();
    };

    setValue = (event) => {
        this.props.isEditing();
        const {value} = event.target;
        this.setState({value});
        this.props.getTextLengthCallback((value || '').length);
    };

    render() {
        const { getTextLengthCallback, ...newProps } = this.props
        return <Form.Input {...newProps}
                           value={this.state.value}
                           onChange={this.setValue}
                           onBlur={this.onBlur} />;
    }
}

export default catchUnsavedChanges(OnBlurTextInput);



// WEBPACK FOOTER //
// ./public/components/forms/BasicFormFields/OnBlurTextInput.jsx